import script from "./TressModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressModal.vue?vue&type=script&lang=ts&setup=true"

import "./TressModal.vue?vue&type=style&index=0&id=93a1db30&lang=scss"
import "./TressModal.vue?vue&type=style&index=1&id=93a1db30&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93a1db30"]])

export default __exports__